import { Link } from 'react-router-dom';

import { usePageMeta } from '../hooks/usePageMeta';
import { useT } from '../i18n/LanguageProvider';

export default function NotFoundPage() {
  const t = useT();

  usePageMeta(t.notFound.metaTitle, t.notFound.metaDescription);

  return (
    <section className="section">
      <p className="eyebrow">404</p>
      <h1 style={{ fontSize: 'clamp(36px, 4.5vw, 60px)' }}>{t.notFound.title}</h1>
      <p className="lead" style={{ marginTop: 22 }}>
        {t.notFound.lead}
      </p>
      <div className="actions" style={{ marginTop: 30 }}>
        <Link className="button primary" to="/">
          {t.notFound.home}
        </Link>
        <Link className="button secondary" to="/kontakt">
          {t.notFound.contact}
        </Link>
      </div>
    </section>
  );
}
